import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import BookingCalendarEntry from '../components/Calendar/BookingCalendarEntry';

class BookingCalendarEntryContainer extends Component {
    static propTypes = {
        bookings: PropTypes.array,
    }

    render() {
        return (
            <BookingCalendarEntry { ...this.props } />
        );
    }
}

function mapStateToProps(state) {
    const { plant, persons } = state.entities;
    const { user } = state.environment;

    return {
        plant,
        persons,
        user,
    };
}

// May need to do mapDispatchToProps(dispatch) to pass any actions down to the Calendar component.

export default connect(mapStateToProps)(BookingCalendarEntryContainer);



// WEBPACK FOOTER //
// ./scripts/containers/BookingCalendarEntryContainer.jsx